import { useEffect, useState } from "react"

type UseVisualViewport = {
    vvOffsetTop: number
}

const VIEWPORT_DELAY = 100

export function useVisualViewport(): UseVisualViewport {
    const [vvOffsetTop, setVvOffsetTop] = useState<number>(0)

    useEffect(() => {
        const handleResize = () => {
            setTimeout(() => {
                const offsetTop = window.visualViewport?.offsetTop || 0
                setVvOffsetTop(offsetTop)
            }, VIEWPORT_DELAY)
        }

        window.visualViewport?.addEventListener("resize", handleResize)
        return () => {
            window.visualViewport?.removeEventListener("resize", handleResize)
        }
    }, [])

    useEffect(() => {
        if (window.visualViewport) {
            setVvOffsetTop(window.visualViewport.offsetTop)
        }
    }, [])

    return { vvOffsetTop }
}
